import React, { useContext } from "react";
import TrackContext from "../../contexts/track-context";
import { ReactComponent as Play } from "../../assets/play.svg";
import { ReactComponent as Pause } from "../../assets/pause.svg";
import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder.svg";
import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
import { CardContent, Menu, MenuItem } from "@material-ui/core";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import API from "../../services/api";
import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import CookieManager from "../../services/CookieManager";
import { useHistory } from "react-router-dom";
import Helper from "../../services/helper";
import Constants from "../../services/constants";
import SvgInline from "../../pure-components/SvgInLine";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import MewoService from "../../services/mewoService";

export default function AlternateTracks(props) {
  let trackContext = useContext(TrackContext);
  const history = useHistory();
  
  const handleThumbPrintSearch = async(trackId, title) => {
    
      let filter=trackContext.trackFilter
      filter.selectedChildTags=[]
      filter.selectedTags=[]
      filter.url=""
      filter.searchId="";
      filter.fileName="";
      filter.searchText = "";
      filter.searchTitle = title;
      filter.trackId=trackId;
      trackContext.setTrackFilter(filter);
      localStorage.setItem("filter_music" , JSON.stringify(filter))
      trackContext.setShowLoaderMagic(true);
      trackContext.setTrackData([]);
      
      if(trackContext.path.startsWith("/search")||
        trackContext.path==="/"|| 
        trackContext.path.startsWith("/albums") ||
        trackContext.path.startsWith("/artist") || 
        trackContext.path.startsWith("/playlists"))
      {
        history.push( `/search/track/`); 
      }

      let reqObj = {
        url : `public/search`,
        method : 'post',
        data: {
          "query": "",
          "options": 
          {
            trackId : trackId,
            "filters": {
              ...trackContext.searchTags,
              exclude : []
            },
            "size": Constants.MEWO_TRACK_SEARCH_BATCH_SIZE,
            "search_descriptions": trackContext.searchDescription ? trackContext.searchDescription : false
          }
        },
      };
      await MewoService.loadMewoData(reqObj).then(res => {
        if(res){
          trackContext.setShowLoaderMagic(false);
          trackContext.setTrackData(res.hits);
          trackContext.setTotaltracks(res.total.value);
        }else{
          Helper.handleError(res);
        }
      }).catch((err) => {
        toast(({ closeToast }) => <ErrorToast message={"Track Loading Error : " + err?.response?.data?.message}/>);
      }).finally(() => {
        trackContext.setShowLoaderMagic(false);
      });
  };
  return (
    <>
{props.alternateVersions.map((alternateVersion, i) => (
  <div 
    className="flex w-full flex-col lg:flex-row items-center border-b border-gray-300 py-2 " 
    key={alternateVersion.id}
  >
    {/* Play Button + Track Info */}
    <div className="flex flex-col lg:flex-row items-start lg:items-center  w-full lg:w-1/2 lg:justify-between space-y-2 lg:space-y-0 lg:space-x-2">
      <div className="flex  w-full">
        <div className="flex-1 flex">
      <div className="p-1 flex  ">
        <button
          aria-label="Play or Pause"
          className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors border border-gray-400 shadow-sm flex items-center justify-center"
          onClick={() => props.fetchTrack(alternateVersion.id, true)}
        >
          {trackContext.playPause && alternateVersion.id === trackContext.currentTrackDetail.id ? (
            <Pause className="w-6 h-6 lg:w-8 lg:h-8  text-gray-700" />
          ) : (
            <Play className="w-6 h-6 lg:w-8 lg:h-8 text-gray-700" />
          )}
        </button>
      </div>
      
      
        <div className="w-full lg:w-auto overflow-hidden  truncate ">
        <div className="font-semibold text-xs lg:text-sm text-gray-800">
  {alternateVersion?.display_title?.length > 20 
    ? alternateVersion?.display_title.substring(0, 20) + '...' 
    : alternateVersion?.display_title}
</div>
          <div className="text-xs  lg:text-sm text-gray-600 truncate">
            {alternateVersion?.artists_publishing_ownerships?.[0]?.artist.full_name}
          </div>
        </div>
        </div>
        <div className="text-gray-600 text-xs lg:text-sm w-full lg:w-1/3  text-right pr-1 lg:pr-0 lg:text-left  ">
  {alternateVersion?.version?.names?.[0]?.value}


      </div>
      </div>
    </div>

   <div className="flex flex-col lg:flex-row items-center w-full lg:w-1/2  space-y-2 lg:space-y-0 lg:space-x-2">
     {/* Waveform */}
    <div className="w-full lg:w-2/5 flex justify-center md:justify-start py-1">
      <SvgInline url={alternateVersion.waveform.small.url} width="100%" />
    </div>

  <div className="flex justify-around items-center lg:justify-end w-full lg:w-auto ">
      {/* BPM & Duration */}
      <div className="w-1/2   flex justify-around  text-gray-600 text-sm">
      <span>{Math.round(alternateVersion.bpm)} BPM</span>
      <span>{alternateVersion.duration && new Date(alternateVersion.duration * 1000).toISOString().substr(14, 5)}</span>

    </div>
   {/* Action Icons */}
   <div className="w-1/2  flex justify-center items-center  space-x-2 p-2 ">
      <ThumbPrint
        className="cursor-pointer hover:scale-105 transition transform w-6 h-6 lg:w-8 lg:h-8"
        onClick={() => props.handleMagicWandClick({ id: alternateVersion.id, title: alternateVersion?.display_title })}
      />
      {props.favs.includes(alternateVersion.id) ? (
        <FavoriteIcon
          onClick={() => props.handleAddTrackToFavorites(alternateVersion.id)}
          className="cursor-pointer text-red-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
        />
      ) : (
        <UnFavoriteIcon
          onClick={() => props.handleAddTrackToFavorites(alternateVersion.id)}
          className="cursor-pointer text-gray-600 hover:text-red-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
        />
      )}
      <CreateNewFolderIcon
        onClick={() => props.handleProjectModal(alternateVersion.id)}
        className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 mt-3 transition w-8 h-8 lg:w-8 lg:h-8"
      />
      {props.download.includes(alternateVersion.id) ? (
        <Activedownload
          onClick={(event) => props.handleDownloadTrack(event, alternateVersion.id)}
          className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
        />
      ) : (
        <GetAppIcon
          onClick={(event) => props.handleDownloadTrack(event, alternateVersion.id)}
          className="cursor-pointer text-gray-700 hover:text-blue-600 hover:scale-110 transition w-6 h-6 lg:w-8 lg:h-8"
        />
      )}
    </div>
  </div>
 
   </div>
  </div>
))}


    </>
  );
}
